import { selectAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const config = createMultiStyleConfigHelpers(selectAnatomy.keys);

const articleManagement = config.definePartsStyle({
  field: {
    background: 'articleManagement.inputBackground',
    borderColor: 'articleManagement.inputBorder',
    borderRadius: 0,
    height: '42px',
    _focusVisible: {
      borderColor: 'articleManagement.text',
      boxShadow: 'none',
    },
    _hover: {
      borderColor: 'articleManagement.inputBorderHover',
    },
  },
  icon: {
    color: 'articleManagement.text',
  },
});

const texas = config.definePartsStyle({
  field: {
    bg: 'texas.bg.800',
    borderBottom: '2px solid',
    borderBottomColor: 'gray.600',
    borderRadius: 'none',
    color: 'white',
    px: 3,
    _focus: {
      borderBottomColor: 'texas.sand.100',
    },
    _light: {
      bg: 'gray.10',
      borderBottomColor: 'gray.100',
      color: 'texas.bg.900',
      _focus: {
        borderBottomColor: 'texas.burntSienna.100',
      },
    },
  },
  icon: {
    color: 'gray.200',
    _light: { color: 'gray.500' },
  },
});

const entityDirectory = config.definePartsStyle({
  field: {
    background: 'entityDirectory.inputBackground',
    border: '1px solid',
    borderColor: 'entityDirectory.secondaryBorder',
    borderRadius: 0,
    color: 'entityDirectory.text',
    _hover: { borderColor: 'entityDirectory.mutedText' },
    _focusVisible: {
      borderColor: 'entityDirectory.primaryBackground',
      boxShadow: 'none',
    },
  },
  icon: { color: 'entityDirectory.mutedText' },
});

export default config.defineMultiStyleConfig({
  variants: {
    articleManagement,
    entityDirectory,
    texas,
  },
});
